import classnames from 'classnames';
import { FC, PropsWithChildren } from 'react';
import ScrollIntoViewIfNeeded from 'react-scroll-into-view-if-needed';

export interface ProductCategoryItemProps {
  e2e?: string;
  className?: string;
  isItemSelected?: boolean;
  onItemClick?: () => void;
  onItemDoubleClick?: () => void;
}

export const ProductCategoryItem: FC<PropsWithChildren<ProductCategoryItemProps>> = ({
  e2e,
  className,
  children,
  isItemSelected,
  onItemClick,
  onItemDoubleClick,
}) => {
  return (
    <ScrollIntoViewIfNeeded
      role="button"
      data-e2e={e2e}
      elementType="div"
      className={classnames(
        'btn btn-block btn-lg btn-text-icon border-bottom border-opacity-20',
        isItemSelected ? 'btn-flat-info selected' : 'btn-flat-primary',
        className,
      )}
      style={{ backgroundColor: isItemSelected ? 'rgba(var(--bs-info-rgb, var(--info-rgb)), 0.1)' : '' }}
      onClick={onItemClick}
      onDoubleClick={onItemDoubleClick}
      active={isItemSelected}
    >
      <div className="ps-0 flex-grow-1 d-flex align-items-center flex-between">{children}</div>
    </ScrollIntoViewIfNeeded>
  );
};
